require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-hersheys-korea.json") })
        }
      }, "path---project-hersheys-korea");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-hersheys-korea!./.cache/json/project-hersheys-korea.json
// module id = 347
// module chunks = 231608221292675